import React from "react";
import { Button } from "@mui/material";

export function ButtonCompartilhar({ disabled, style, sx, ...props }: any) {
  return (
    <Button
      {...props}
      disabled={disabled}
      style={{
        backgroundColor: "#4A76FB",
        color: "#FFFFFF",
        marginLeft: 8,
        height: 36,
        borderRadius: 4,
        boxShadow: "none",
        textTransform: "none",
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        "&.Mui-disabled": {
          opacity: 0.5,
          color: "#FFFFFF",
          backgroundColor: "#4A76FB",
        },
        ...sx,
      }}
      variant="contained"
    >
      Compartilhar
    </Button>
  );
}
